import { useEffect, useState } from 'react';

export function useStickyFilter() {
  const [stickyFilter, setStickyFilter] = useState(false);
  const makeFilterSticky = () => {
    if (window.scrollY > 54) {
      setStickyFilter(true);
    } else {
      setStickyFilter(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', makeFilterSticky);
    return () => {
      window.removeEventListener('scroll', makeFilterSticky);
    };
  }, []);

  return stickyFilter;
}
